import {Card, CardBody, CardHeader, Typography,} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import {CardFooterPaginator} from "../../system/cardFooterPaginator";
import {getBackOfficeAgentBranchFees} from "../../../services/back_office/agent_branch_fee";
import {BackOfficeAgentBranchFeeForm} from "./form";
import {BackOfficeAgentBranchFeeGrid} from "./grid";
import SelectInput from "../../system/select";
import {getPersonsNameAndFamily} from "../../../services/profile/profile";


export function BackOfficeAgentBranchFeeManagement() {

  const [agentBranchFee, setAgentBranchFees] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [gridRowCount, setGridRowCount] = useState(5);
  const [gridCurrentPage, setGridCurrentPage] = useState(1);
  const [gridSelectedRow, setGridSelectedRow] = useState(null);
  const [gridTotalRowCount, setGridTotalRowCount] = useState(0);
  const [sortBy, setSortBy] = useState("branch_id")
  const [sortType, setSortType] = useState(false);
  const [from, setFrom] = useState((gridCurrentPage - 1) * gridRowCount + 1);
  const [to, setTo] = useState((gridCurrentPage) * gridRowCount);
  const [lastDataRefresh, setLastDataRefresh] = useState(null);

  const [personId, setPersonId] = useState(null);

  useEffect(() => {
    if ((gridCurrentPage) * gridRowCount <= gridTotalRowCount) {
      setTo((gridCurrentPage) * gridRowCount)
    } else {
      setTo(gridTotalRowCount)
    }
    if (gridTotalRowCount === 0) {
      setFrom(0)
    } else {
      setFrom((gridCurrentPage - 1) * gridRowCount + 1)
    }
  }, [gridCurrentPage, gridRowCount, gridTotalRowCount]);

  async function getData(paginate) {
    if (personId) {
      const result = await getBackOfficeAgentBranchFees(paginate);
      if (result.status === 200) {
        const {agentBranchFeeList, total_count} = result.data;
        setAgentBranchFees(agentBranchFeeList || []);
        setGridTotalRowCount(total_count);
      }
    }
  }

  useEffect(() => {
    const paginate = new URLSearchParams({
      "sort_by": sortBy,
      "sort_type": sortType === false ? "DESC" : "ASC",
      "limit": parseInt(gridRowCount),
      "offset": (parseInt(gridCurrentPage) - 1) * parseInt(gridRowCount),
      "person_id": personId,
    }).toString()

    getData(paginate)
  }, [personId, lastDataRefresh, gridCurrentPage, gridRowCount, sortBy, sortType]);

  return (
    <div className="">
      <BackOfficeAgentBranchFeeForm
        agentBranchFee={gridSelectedRow}
        open={modalOpen}
        setOpen={setModalOpen}
        setLastDataRefresh={setLastDataRefresh}
        setGridSelectedRow={setGridSelectedRow}
        setAgentBranchFees={setAgentBranchFees}
        personId={personId}
      />
      <Card className="pt-8">
        <CardHeader floated={true} shadow={false} className="rounded-none h-fit overflow-y-visible">
          <div className="mb-8 flex items-center justify-between gap-8">
            <Typography variant="h5" color="blue-gray">تعیین تعرفه مشاوره و خدمات</Typography>
          </div>

          <div className="flex flex-col mb-4 overflow-y-visible">
            <SelectInput
              label={"کاربر"}
              defaultValue={personId}
              refreshSignal={personId}
              // multiselect={false}
              autoLoadService={getPersonsNameAndFamily}
              autoLoadRender={({name, family}) => {
                return name + " " + family
              }}
              onChange={setPersonId}
            />
          </div>

        </CardHeader>
        <CardBody className="overflow-x-auto w-full">
          <BackOfficeAgentBranchFeeGrid
            AgentBranchFees={agentBranchFee}
            setModalOpen={setModalOpen}
            setSelectedRow={setGridSelectedRow}
            setSortBy={setSortBy}
            sortType={sortType}
            setSortType={setSortType}
          />
        </CardBody>
        <CardFooterPaginator
          active={gridCurrentPage}
          setActive={setGridCurrentPage}
          totalRows={gridTotalRowCount}
          rowsCount={gridRowCount}
          setRowsCount={setGridRowCount}
          from={from}
          to={to}
        />
      </Card>
    </div>
  );
}